(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["velavio-cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velavio-cart-upsell')) {
  customElements.define('velavio-cart-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('button')?.addEventListener('click', async (event) => {
        const button = event.currentTarget;
        const drawer = this.closest('cart-drawer');
        button.disabled = true;
        this.querySelector('[role="alert"]').hidden = true;
        try {
          const response = await fetch(window.routes.cart_add_url, {
            method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
            body: JSON.stringify({items:[{id:button.dataset.variant,quantity:Number(button.dataset.quantity)||1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description);
          drawer.renderContents(result);
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source:'velavio-upsell',cartData:result});
        } catch (error) {
          this.querySelector('[role="alert"]').hidden = false;
          button.disabled = false;
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["velavio-gallery-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velavio-gallery-controls')) {
  customElements.define('velavio-gallery-controls', class extends HTMLElement {
    connectedCallback() {
      if (this.gallery) return;
      this.gallery = this.closest('.product__media-wrapper')?.querySelector('media-gallery');
      if (!this.gallery) return;
      this.viewer = this.gallery.querySelector('[id^="GalleryViewer-"]');
      this.list = this.viewer.querySelector('[id^="Slider-Gallery-"]');
      this.viewer.append(this);
      const fit = () => { const vb = this.viewer.getBoundingClientRect(), lb = this.list.getBoundingClientRect(); this.style.top = Math.max(0, Math.round(lb.top - vb.top)) + 'px'; this.style.bottom = Math.max(0, Math.round(vb.bottom - lb.bottom)) + 'px'; };
      fit(); window.addEventListener('resize', fit); if (window.ResizeObserver) new ResizeObserver(fit).observe(this.list);
      this.hidden = this.list.querySelectorAll('.product__media-item[data-media-id]').length < 2;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button || typeof this.gallery.setActiveMedia !== 'function') return;
        const slides = Array.from(this.list.querySelectorAll('.product__media-item[data-media-id]'));
        let index = slides.findIndex(slide => slide.classList.contains('is-active'));
        if (window.matchMedia('(max-width:749px)').matches) {
          index = slides.reduce((closest, slide, i) =>
            Math.abs(slide.offsetLeft - this.list.scrollLeft) < Math.abs(slides[closest].offsetLeft - this.list.scrollLeft) ? i : closest, 0);
        }
        const next = (Math.max(index, 0) + Number(button.dataset.direction) + slides.length) % slides.length;
        this.gallery.setActiveMedia(slides[next].dataset.mediaId, false);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
